import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger);

export function paBsPipeAnim() {
    const pipes = document.querySelectorAll('.bs-pipe');
    if (!pipes.length) return;
    const pipeAnims = document.querySelectorAll('.bs-pipe-anim');

    gsap.set(pipes, {
        opacity: 0
    });

    gsap.set(pipeAnims, {
        drawSVG: '0% 0%'
    });

    pipes.forEach((pipe) => {
        let pipeAnim = pipe.querySelector('.bs-pipe-anim');

        gsap.to(pipe, {
            opacity: 1
        });

        if (pipeAnim) {
            const rawDuration = parseFloat(pipeAnim.dataset.pipeAnimDuration);
            const duration = Number.isFinite(rawDuration) ? rawDuration : 1;

            gsap.to(pipeAnim, {
                drawSVG: '0% 100%',
                opacity: 1,
                duration: duration,
                ease: 'power1.out',
                scrollTrigger: {
                    trigger: pipe,
                    start: 'top 75%'
                }
            });
        }
    });
}
